"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixKeys = exports.filterOptions = exports.copyOptions = exports.VIRTUALIZED_SELECTORS = exports.LEGACY_SELECT_SELECTORS = exports.DROPDOWN_SELECTORS = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// note that this function mutates directly!
var fixKeys = exports.fixKeys = function fixKeys(options) {
  if (options && Array.isArray(options)) {
    options.forEach(function (option) {
      if (option.hasOwnProperty('text') || option.hasOwnProperty('name')) {
        option.value = option.id;
        option.label = option.text || option.name;
        option.options = option.children;
        if (option.options && option.options.length > 0) {
          fixKeys(option.options);
        }
      }
    });
    return options;
  }
};
function isEmpty(str) {
  return !str || str.length === 0;
}
function matchesFilter(option, filter) {
  if (isEmpty(filter)) {
    return true;
  }
  return option.label && option.label.toLowerCase().includes(filter.toLowerCase());
}
var copyOptions = exports.copyOptions = function copyOptions(input) {
  if ((0, _typeof2["default"])(input) !== 'object' || input === null) {
    return input;
  }
  var outObject = Array.isArray(input) ? [] : {};
  for (var key in input) {
    if (!input.hasOwnProperty(key)) continue;
    var value = input[key];
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
    outObject[key] = copyOptions(value);
  }
  return outObject;
};

// note that this function mutates directly as well, copy options first if needed
// @ts-expect-error - TS7023 - 'filterOptions' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions.
var filterOptions = exports.filterOptions = function filterOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var filter = arguments.length > 1 ? arguments[1] : undefined;
  var currentValues = arguments.length > 2 ? arguments[2] : undefined;
  if (!options) {
    return [];
  }
  return options.filter(function (option) {
    // @ts-expect-error - TS7022 - 'matchingChildren' implicitly has type 'any' because it does not have a type annotation and is referenced directly or indirectly in its own initializer.
    var matchingChildren = filterOptions(option.options, filter, currentValues);

    // @ts-expect-error - TS7022 - 'hasMatchingChildren' implicitly has type 'any' because it does not have a type annotation and is referenced directly or indirectly in its own initializer.
    var hasMatchingChildren = matchingChildren && matchingChildren.length > 0;
    if (hasMatchingChildren) {
      option.options = matchingChildren;
    }
    var currentlySelected = currentValues ? currentValues.some(function (cv) {
      return cv.value === option.value;
    }) : false;
    return (matchesFilter(option, filter) || hasMatchingChildren) && !currentlySelected;
  });
};
var DROPDOWN_SELECTORS = exports.DROPDOWN_SELECTORS = {
  container: 'div.sl-dropdown-container',
  controller: 'div.sl-dropdown__control',
  clear_indicator: 'div.sl-dropdown__clear-indicator',
  arrow_indicator: 'div.sl-dropdown__dropdown-indicator',
  is_disabled: 'div.sl-dropdown--is-disabled',
  is_open: 'div.sl-dropdown__control--menu-is-open',
  placeholder_text: 'div.sl-dropdown__placeholder',
  selected_value: 'div.sl-dropdown__single-value',
  multi_selected_values: 'span[data-provides="chip-text"]',
  option: 'div.sl-dropdown__option',
  focused_option: 'div.sl-dropdown__option--is-focused',
  selected_option: 'div.sl-dropdown__option--is-selected',
  disabled_option: 'div.sl-dropdown__option--is-disabled',
  no_options_message: 'div.sl-dropdown__menu-notice--no-options',
  loading_message: 'div.sl-dropdown__menu-notice--loading'
};
var LEGACY_SELECT_SELECTORS = exports.LEGACY_SELECT_SELECTORS = {
  container: 'div.Select',
  controller: 'div.Select-control',
  clear_indicator: 'div.Select-clear',
  arrow_indicator: 'div.Select .Select-arrow-zone',
  is_disabled: 'div.Select.is-disabled',
  is_open: 'div.Select.is-open',
  placeholder_text: 'div.Select-placeholder',
  selected_value: 'div.Select-value-label',
  multi_selected_values: 'span[data-test-role="react-chosen-multiselect-option"]',
  option: 'div.Select-option',
  focused_option: 'div.Select-option.is-focused',
  selected_option: 'div.Select-option.is-selected',
  disabled_option: 'div.Select-option.is-disabled',
  no_options_message: 'div.Select-no-options',
  loading_message: 'div.Select-loading'
};
var VIRTUALIZED_SELECTORS = exports.VIRTUALIZED_SELECTORS = _objectSpread(_objectSpread({}, LEGACY_SELECT_SELECTORS), {}, {
  option: 'div.VirtualizedSelectOption',
  focused_option: 'div.VirtualizedSelectSelectedOption',
  selected_option: 'div.VirtualizedSelectFocusedOption',
  disabled_option: 'div.VirtualizedSelectDisabledOption'
});